// extracted by mini-css-extract-plugin
export var attachment = "_sg-a";
export var emailContainer = "_sg-4";
export var emailContentPaddedContainer = "_sg-b";
export var emailHeader = "_sg-6";
export var emailIframe = "_sg-3";
export var emailInfoIcon = "_sg-9";
export var emailShortenedSummary = "_sg-e";
export var infoDropdown = "_sg-0";
export var infoRowBoundedContent = "_sg-d";
export var internal = "_sg-5";
export var merchant = "_sg-8";
export var messageInputContainer = "_sg-h";
export var normal = "_sg-7";
export var replyCard = "_sg-f";
export var subtleButton = "_sg-1";
export var subtleButtonIconContainer = "_sg-2";
export var toggleViewRepliesButton = "_sg-c";
export var wrappingText = "_sg-g";